import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import FileUploaderSelect from "./FileUploaderSelect";
import RecognizeTextViewer from "./RecognizeTextViewer";
//

const RecognizeTextComponent = (props) => {
    const {
        titleDragNDropSomeFilesHereOrClickToSelectFiles,
        titleDownload,
        titleChoose,
        titleLoadMore,
        titleSelect,
        titleDelete,
        titleReady,
        titleCancel,
        titleCopy,
        titleCopied,
        titleRecognizeText,
        /* titleRecognizeTextAll, */
    } = props.attributes;

    const [imageUrl, setImageUrl] = useState("");
    const [imageWidthExt, setImageWidthExt] = useState("");
    const [imageHeightExt, setImageHeightExt] = useState("");
    const [fileId, setFileId] = useState("");
    const [fileName, setFileName] = useState("");
    const [showComponent, setShowComponent] = useState("");

    const handleDataChange = (
        url,
        imageWidthExt,
        imageHeightExt,
        fileId,
        fileName
    ) => {
        setImageUrl(url);
        setImageWidthExt(imageWidthExt);
        setImageHeightExt(imageHeightExt);
        setFileId(fileId);
        setFileName(fileName);
        setShowComponent(true);
    };

    const [showUploader, setShowUploader] = useState(true);

    return (
        <div>
            {showComponent && (
                <>
                    <RecognizeTextViewer
                        imageWidthExt={imageWidthExt}
                        imageHeightExt={imageHeightExt}
                        fileId={fileId}
                        fileName={fileName}
                        imageUrl={imageUrl}
                        setShowUploader={setShowUploader}
                        attributes={props.attributes}
                    />
                </>
            )}

            <div style={{ marginTop: "20px" }}>
                <FileUploaderSelect
                    attributes={props.attributes}
                    componentRequestData={"ImageData"}
                    setShowComponent={setShowComponent}
                    showUploader={showUploader}
                    onDataChange={handleDataChange}
                />
            </div>
        </div>
    );
};

export default RecognizeTextComponent;

/* if (document.getElementById("recognize-text")) {
    const recognizeTextElement = document.getElementById("recognize-text");
    const root = createRoot(recognizeTextElement);
    const attributes = {
        localeCode: recognizeTextElement.getAttribute("localeCode"),
        titleDragNDropSomeFilesHereOrClickToSelectFiles:
            recognizeTextElement.getAttribute(
                "titleDragNDropSomeFilesHereOrClickToSelectFiles"
            ),
        titleDownload: recognizeTextElement.getAttribute("titleDownload"),
        titleDownloadAll: recognizeTextElement.getAttribute("titleDownloadAll"),
        titleChoose: recognizeTextElement.getAttribute("titleChoose"),
        titleLoadMore: recognizeTextElement.getAttribute("titleLoadMore"),
        titleSelect: recognizeTextElement.getAttribute("titleSelect"),
        titleDelete: recognizeTextElement.getAttribute("titleDelete"),
        titleDeleteAll: recognizeTextElement.getAttribute("titleDeleteAll"),
        titleReady: recognizeTextElement.getAttribute("titleReady"),
        titleCurrentFile: recognizeTextElement.getAttribute("titleCurrentFile"),
        titleCancel: recognizeTextElement.getAttribute("titleCancel"),
        titleCopy: recognizeTextElement.getAttribute("titleCopy"),
        titleCopied: recognizeTextElement.getAttribute("titleCopied"),

        titleModel: recognizeTextElement.getAttribute("titleModel"),
        titleWidth: recognizeTextElement.getAttribute("titleWidth"),
        titleHeight: recognizeTextElement.getAttribute("titleHeight"),
        titleRecognize: recognizeTextElement.getAttribute("titleRecognize"),
        titleChooseIntendedLanguage: recognizeTextElement.getAttribute(
            "titleChooseIntendedLanguage"
        ),
        titleRecognizeTextAnotherImage: recognizeTextElement.getAttribute(
            "titleRecognizeTextAnotherImage"
        ),
        titleApplyFilter: recognizeTextElement.getAttribute("titleFilter"),
        tip1: recognizeTextElement.getAttribute("tip1"),
        serverUploadUrl: recognizeTextElement.getAttribute("serverUploadUrl"),
    };
    root.render(<RecognizeTextComponent attributes={attributes} />);
} */

if (document.getElementById("recognize-text")) {
    const recognizeTextElement = document.getElementById("recognize-text");
    const root = createRoot(recognizeTextElement);
    const attributes = { ...recognizeTextElement.dataset };
    root.render(<RecognizeTextComponent attributes={attributes} />);
}
